import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export function actionFormValidator(): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const commonActionControl = formGroup.get('commonAction');
    const customActionControl = formGroup.get('customAction');
    const wheelControl = formGroup.get('wheel');

    const commonAction = commonActionControl?.value;
    const customAction = customActionControl?.value;

    if (!commonAction && !customAction) {
      return { actionRequired: true };
    }

    if (typeof commonAction === 'object' && commonAction.multiWheel === true && !wheelControl?.value) {
      return { wheelRequired: true };
    }

    return null; // Validation passes
  };
}

